import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Home, Building2, HandCoins, Briefcase, Layers, Mail, ArrowRight, Instagram } from "lucide-react";
import { api } from "@/lib/api";

const BUTTONS = [
  { to: "/sell", label: "Sell My Property", icon: Home },
  { to: "/contact", label: "Partner With Us", icon: Layers },
  { to: "/investors", label: "Join Investor List", icon: HandCoins },
  { to: "/buyers", label: "Join Buyer List", icon: Briefcase },
  { to: "/deals", label: "View Current Projects", icon: Building2 },
  { to: "/contact", label: "Contact Brightside Capital", icon: Mail },
];

export default function Start() {
  const [pub, setPub] = useState({ instagram_url: "" });
  useEffect(() => { api.get("/public-settings").then((r) => setPub(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-black bp-grid relative" data-testid="start-page">
      <div className="absolute inset-0 hero-vignette pointer-events-none" />
      <div className="relative max-w-md mx-auto px-5 py-16">
        <div className="text-center">
          <div className="inline-flex h-12 w-12 items-center justify-center border border-[#C19B6C] text-[#C19B6C] font-display font-bold text-xl mx-auto">B</div>
          <div className="font-display text-2xl mt-4">Brightside Capital Ventures</div>
          <div className="text-xs tracking-widest uppercase text-[#C19B6C] mt-2">Sacramento · Real Estate Investment</div>
          <p className="text-sm text-neutral-400 mt-4 leading-relaxed">Creative solutions to maximize your options.</p>
        </div>
        <div className="mt-10 space-y-3">
          {BUTTONS.map((b) => (
            <Link key={b.label} to={b.to} className="card-frame flex items-center justify-between px-5 py-4 hover:border-[#C19B6C]/60" data-testid={`start-${b.label.toLowerCase().replace(/[^a-z]/g,'-')}`}>
              <span className="flex items-center gap-3 text-white"><b.icon size={18} className="text-[#C19B6C]" />{b.label}</span>
              <ArrowRight size={16} className="text-neutral-500" />
            </Link>
          ))}
          {pub.instagram_url && (
            <a href={pub.instagram_url} target="_blank" rel="noreferrer" className="card-frame flex items-center justify-between px-5 py-4">
              <span className="flex items-center gap-3 text-white"><Instagram size={18} className="text-[#C19B6C]" />Instagram</span>
              <ArrowRight size={16} className="text-neutral-500" />
            </a>
          )}
        </div>
        <div className="mt-12 text-center text-xs text-neutral-500">
          <Link to="/" className="hover:text-[#C19B6C]">brightsidecapital.net</Link>
        </div>
      </div>
    </div>
  );
}
